import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NavigationComponent } from '../shared/components';
import {
  AccountInformationComponent,
  ContactComponent,
  HighlightsComponent,
  HomeComponent,
  ImprintComponent,
  PrivacyPolicyComponent,
} from './components';
import { TermsOfServiceComponent } from './components/terms-of-service/terms-of-service.component';
import { LoggedInGuard } from '../../core/guards/logged-in.guard';
import { ChangePinComponent } from './components/change-pin/change-pin.component';

const routes: Routes = [
  {
    path: '',
    children: [
      { path: 'home', canActivate: [LoggedInGuard], component: HomeComponent },
      {
        path: 'pages/account-information',
        canActivate: [LoggedInGuard],
        component: AccountInformationComponent,
      },
      {
        path: 'pages/contact',
        canActivate: [LoggedInGuard],
        component: ContactComponent,
      },
      {
        path: 'pages/highlights',
        canActivate: [LoggedInGuard],
        component: HighlightsComponent,
      },
      {
        path: 'pages/imprint',
        canActivate: [LoggedInGuard],
        component: ImprintComponent,
      },
      { path: 'pages/privacy-policy', component: PrivacyPolicyComponent },
      {
        path: 'pages/terms-of-service',
        canActivate: [LoggedInGuard],
        component: TermsOfServiceComponent,
      },
      {
        path: 'pages/change-pin',
        canActivate: [LoggedInGuard],
        component: ChangePinComponent,
      },
    ],
  },
  { path: '', component: NavigationComponent, outlet: 'navigation' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {}
